import { createContext, Dispatch, SetStateAction } from 'react';

import { PREFERS_DARK_MODE } from '../constants/localState';

export interface UserSettings {
  darkMode?: boolean;
  isMobileDrawerOpen?: boolean;
  isDesktopDrawerOpen?: boolean;
}

export const getPrefersDarkMode = (): undefined | boolean => {
  const currentlyStored = localStorage.getItem(PREFERS_DARK_MODE);
  return !currentlyStored ? undefined : currentlyStored === 'true';
};

export const setPrefersDarkMode = (preference?: boolean): void => {
  if (preference === undefined) {
    localStorage.setItem(PREFERS_DARK_MODE, '');
  } else {
    localStorage.setItem(PREFERS_DARK_MODE, preference.toString());
  }
};

export const initialUserSettings: UserSettings = {
  darkMode: getPrefersDarkMode() || false, // Undefined to listen to the browser/OS settings -> defaulted to false to disable
  isMobileDrawerOpen: false,
  isDesktopDrawerOpen: true,
};

export const UserSettings = createContext<[UserSettings, Dispatch<SetStateAction<UserSettings>>]>([
  initialUserSettings,
  () => {
    // Can be empty, will be set by useState()
  },
]);
